module.exports = __webpack_public_path__ + "static/img/yd.490a4e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yd.png
// module id = WC6Z
// module chunks = 0